import { colors, Tag } from '@sweep-io/sweep-design';
import { ConfigurationToName } from '../dependencies/types';
import { formatCamelCase } from '../universal-search/utils';

export const TypeTag = ({ configurationType }: { configurationType: string }) => {
  return (
    <Tag
      size="tiny"
      color={colors.grey[120]}
      label={ConfigurationToName[configurationType] ?? formatCamelCase(configurationType)}
    />
  );
};
